module.exports = __webpack_public_path__ + "static/img/4.f603afa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/4/4.png
// module id = d11M
// module chunks = 1